/**
 * Map a push-notification data payload to an in-app route.
 *
 * The `data` argument comes from the backend's notify_user call — shape
 * depends on the event type. Keep in sync with the notify_user invocations
 * in the Lambda handlers:
 *   - functions/ai/handler.py        (order_fill)
 *   - functions/bots/handler.py      (stop / tp1 / tp2 / tp3)
 *   - strategist/execution.py        (strategist_high_conviction)
 *
 * Unknown events return null — the caller should stay on the current page
 * instead of navigating somewhere surprising.
 */
export function routeForPushData(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const d = data as Record<string, unknown>;
  const event = typeof d.event === 'string' ? d.event : '';
  const symbol = typeof d.symbol === 'string' ? d.symbol : '';

  if (event === 'order_fill' || event === 'stop' || event === 'tp1' || event === 'tp2' || event === 'tp3') {
    return '/positions';
  }
  if (event === 'strategist_high_conviction' && symbol) {
    const side = d.action === 'OPEN_SHORT' ? 'short' : 'buy';
    return `/quick-trade?symbol=${encodeURIComponent(symbol)}&action=${side}`;
  }
  return null;
}
